import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface UpdateModalSingleUseCase {
    invoke: (modalId: number, data: FormData) => Promise<boolean>;
  }
  
  export class UpdateModalSingle implements UpdateModalSingleUseCase {
    private Repo: OffersPromoRepository;
    constructor(_Repo: OffersPromoRepository) {
      this.Repo = _Repo;
    }
  
    async invoke(modalId: number, data: FormData){
       
        if(!data){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.Repo.updateModalSingle(modalId, data);
        return update;
    }
  }